import React from "react";
import { Navigate } from "react-router-dom";

const AccessRoute = ({ children, liveUser, requiredAccess }) => {
  if (!liveUser) return null; // wait for API

  if (!requiredAccess) return children;

  if (!liveUser[requiredAccess]) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AccessRoute;